import { render, staticRenderFns } from "./FeedBackList.vue?vue&type=template&id=12acebb6&scoped=true"
import script from "./FeedBackList.vue?vue&type=script&lang=ts"
export * from "./FeedBackList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12acebb6",
  null
  
)

export default component.exports